import { useSelector } from 'react-redux';
import { MapContainer } from './MapContainer';
import StoreDetails from './StoreDetails'

const StoreInfo = (props) => {

    const mapLink = useSelector(state => state.popupData.mapLink);

    return (
        <div className='container-fluid'>
            <div className='row'>
                <div className='col-12'> {mapLink && <MapContainer link={mapLink} />}</div>
            </div>
            <div className='row'>
                <div className='col-12'>
                    <StoreDetails config={props.config}></StoreDetails>
                </div>
            </div>
        </div>
    )
}

export default StoreInfo


